/**
 * Static floating tile — no motion, no parallax. Purely CSS.
 * Keeps every visual identical to the animated version but drops all runtime cost.
 */
export function FloatingTile({
  children,
  className = "",
  rotate = 0,
  edge = "top",
  variant = "dark",
}) {
  const base =
    variant === "glass"
      ? "bg-white/[0.03] border border-white/[0.10] backdrop-blur-2xl"
      : variant === "spotted"
      ? "bg-[#0B0B0B] border border-white/[0.06]"
      : "bg-[#0E0E0E] border border-white/[0.06]";

  return (
    <div
      style={{ transform: `rotate(${rotate}deg)` }}
      className={`relative rounded-[28px] ${base} shadow-[0_40px_80px_-30px_rgba(0,0,0,0.9),0_10px_30px_-10px_rgba(0,0,0,0.7)] overflow-hidden ${className}`}
    >
      {edge === "top" && (
        <span className="pointer-events-none absolute inset-x-8 top-0 h-px bg-gradient-to-r from-transparent via-white/50 to-transparent" />
      )}
      {edge === "bottom" && (
        <span className="pointer-events-none absolute inset-x-8 bottom-0 h-px bg-gradient-to-r from-transparent via-white/30 to-transparent" />
      )}
      {edge === "diagonal" && (
        <span className="pointer-events-none absolute -top-12 -right-12 w-40 h-40 rotate-45 bg-gradient-to-br from-white/20 via-white/[0.05] to-transparent blur-md" />
      )}

      <div className="w-full h-full">{children}</div>

      {variant === "spotted" && (
        <div
          className="pointer-events-none absolute inset-0 opacity-30 mix-blend-screen"
          style={{
            backgroundImage:
              "radial-gradient(circle at 20% 30%, rgba(255,255,255,0.30) 1px, transparent 2px), radial-gradient(circle at 70% 60%, rgba(255,255,255,0.15) 1px, transparent 2px), radial-gradient(circle at 40% 80%, rgba(255,255,255,0.20) 1.5px, transparent 3px), radial-gradient(circle at 85% 20%, rgba(255,255,255,0.12) 1px, transparent 2px)",
            backgroundSize: "60px 60px, 90px 90px, 120px 120px, 70px 70px",
          }}
        />
      )}
    </div>
  );
}

/** Two overlapping ambient halos — pure CSS, no animation. */
export function AmbientHalos() {
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden">
      <div className="absolute -top-[10%] -left-[10%] w-[420px] h-[420px] rounded-full bg-white/[0.06] blur-[100px]" />
      <div className="absolute bottom-[10%] right-[5%] w-[380px] h-[380px] rounded-full bg-white/[0.045] blur-[110px]" />
      <div className="absolute top-[45%] left-[45%] w-[320px] h-[320px] rounded-full bg-white/[0.03] blur-[90px]" />
    </div>
  );
}
